import React from 'react';

export const PublishIcon = props => (
  <svg width="19" height="19" {...props}>
    <path d="M13.5 16h-8A2.5 2.5 0 0 1 3 13.5v-8A2.5 2.5 0 0 1 5.5 3h8A2.5 2.5 0 0 1 16 5.5v8a2.5 2.5 0 0 1-2.5 2.5zm-8-12A1.5 1.5 0 0 0 4 5.5v8A1.5 1.5 0 0 0 5.5 15h8a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 13.5 4z" />
    <path d="M9 11.93L12.9 8a.22.22 0 0 0 0-.31l-.42-.42a.22.22 0 0 0-.31 0l-3.34 3.39-2-2a.18.18 0 0 0-.25 0l-.42.42a.18.18 0 0 0 0 .25L8.72 12a.18.18 0 0 0 .28-.07z" />
  </svg>
);
